import { render, staticRenderFns } from "./statisticsTable.vue?vue&type=template&id=5a05682c&scoped=true&"
import script from "./statisticsTable.vue?vue&type=script&lang=js&"
export * from "./statisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./statisticsTable.vue?vue&type=style&index=0&id=5a05682c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a05682c",
  null
  
)

export default component.exports